import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChargedActSummaryPaidPaymentRequestComponent} from './charged-act-summary-paid-payment-request.component';
import {
    PaymentRequestSummaryModule
} from "../../../../../sale/modules/payment_request/api/component/payment-request-summary/payment-request-summary.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";

@NgModule({
    imports: [
        CommonModule,
        PaymentRequestSummaryModule,
        ButtonModule,
    ],
    declarations: [ChargedActSummaryPaidPaymentRequestComponent],
    exports: [
        ChargedActSummaryPaidPaymentRequestComponent
    ]
})
export class ChargedActSummaryPaidPaymentRequestModule {
}
